module.exports = __webpack_public_path__ + "img/report-animation.7ae8fa36.png";